// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upcoming[data-v-fca34eb0]{margin-block:32px}.upcoming .heading[data-v-fca34eb0]{margin:0 0 16px;font-weight:700;text-transform:uppercase;font-size:16px;color:#6a7c8f}.upcoming p[data-v-fca34eb0]{margin:16px 0 0}.upcoming ul[data-v-fca34eb0]{margin:0;padding-inline-start:24px}", ""]);
// Exports
module.exports = exports;
